import r, { OPTIONS as z } from "../../managers/braze-instance.js";
import { ContentCards, subscribeToContentCardsUpdates } from "../index.js";
import rr from "../content-cards-provider-factory.js";
import { setCardHeight as tn } from "../../Card/display/card-display.js";
import { logger as E } from "../../../shared-lib/index.js";
import { destroyContentCardsHtml as nn, detectContentCardsImpressions as en, contentCardsToHtml as on, LAST_REQUESTED_REFRESH_DATA_ATTRIBUTE as rn, refreshContentCardsUI as sn, registerContentCardsSubscriptionId as an, updateContentCards as cn } from "../../common/content-cards-display.js";
import { setupFeedUI as fn } from "../../ui/js/feed-css.js";
export function showContentCards(n, t) {
  if (!r.rr()) return;
  fn();
  var e = !1;
  null == n && (n = document.body, e = !0);
  var o = r.ee(z.tn) || !1,
    s = rr.o().Ws(!1);
  "function" == typeof t && cn(s, t(s.cards.slice()), s.lastUpdated, null, o);
  var a = on(s, o, e),
    i = rr.o(),
    c = i.Bs();
  (null == s.lastUpdated || new Date().valueOf() - s.lastUpdated.valueOf() > ContentCards.ur) && (null == c || new Date().valueOf() - c > ContentCards.ur) && (E.info("Cached content cards were older than max TTL of ".concat(ContentCards.ur, " ms, requesting an update from the server.")), sn(s, a), i.Es(new Date().valueOf()));
  var f = new Date().valueOf(),
    l = subscribeToContentCardsUpdates(function (n) {
      var e = a.querySelectorAll(".ab-refresh-button")[0];
      if (null != e) {
        var _n = 500,
          _t = _n -= new Date().valueOf() - f;
        var _o = a.getAttribute(rn);
        _o && (_t = parseInt(_o), isNaN(_t) || (_n -= new Date().valueOf() - _t)), setTimeout(function () {
          e.className = e.className.replace(/fa-spin/g, "");
        }, Math.max(_n, 0));
      }
      var r = n.cards;
      "function" == typeof t && (r = t(r.slice())), cn(s, r, n.lastUpdated, a, o);
    });
  an(l, a);
  var u = function u(n) {
    var t = n.querySelectorAll(".ab-feed");
    var o = null;
    for (var _e = 0; _e < t.length; _e++) t[_e].parentNode === n && (o = t[_e]);
    null != o ? (nn(o), null != o.parentNode && o.parentNode.replaceChild(a, o)) : n.appendChild(a), setTimeout(function () {
      a.className = a.className.replace("ab-hide", "ab-show");
    }, 0), e && a.focus(), en(s, a), tn(s.cards, n);
  };
  var d;
  null != n ? u(n) : window.onload = (d = window.onload, function () {
    "function" == typeof d && d(new Event("oldLoad")), u(document.body);
  });
}